var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"col-12 col-md-6 questionare-item",on:{"click":_vm.answer}},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"btn-answer"},[_vm._v("回答する")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f5c11b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/QuestionareItem.vue
// module id = null
// module chunks = 